@if (stores.order.length > 1) {
  <div id="select-store">
    Selected Store:
    <app-shared-custom-select
      (selectionChange)="onStoreSelectionChange($event)"
      [allowMultiple]="false"
      [allowSelectAll]="false"
      [autoSubmitOnSelect]="true"
      [placeholder]="'Select Store'"
      [setOptions]="storeSelectOptions()"
      [showActionButtons]="false"
      [showChips]="false"
      [showSearchBar]="false">
    </app-shared-custom-select>
  </div>
}

@if (selectedStore) {
  <div>
    <table class="threshold-table">
      <thead>
      <tr>
        <th>Description</th>
        <th>Value</th>
      </tr>
      </thead>
      <tbody>
      <tr>
        <td>Maximum Increase in Price</td>
        <td>
          <div class="input-percentage-wrapper">
            <input [ngModel]="thresholds[selectedStore].pos * 100" (keyup)="onValueChange(selectedStore, $event, 'pos')">
            <span class="percentage-symbol">%</span>
          </div>
        </td>
      </tr>
      <tr>
        <td>Maximum Decrease in Price</td>
        <td>
          <div class="input-percentage-wrapper">
            <input
              [ngModel]="thresholds[selectedStore].neg * 100"
              (keyup)="onValueChange(selectedStore, $event, 'neg')"
              min="0" max="100">
            <span class="percentage-symbol">%</span>
          </div>
        </td>
      </tr>
      </tbody>
    </table>
  </div>
}
@if (selectedStore) {
  <button class="button-save" type="button" mat-raised-button (click)="onClickSave($event)">Save</button>
}
